import { addDays, format } from 'date-fns';

export const isToday = (date: number | Date) => format(date, 'yyyy-MM-dd') === format(Date.now(), 'yyyy-MM-dd');

export const isTomorrow = (date: number | Date) =>
  format(date, 'yyyy-MM-dd') === format(addDays(Date.now(), 1), 'yyyy-MM-dd');

export const formatDateWithRelativeText = (date: number | Date) =>
  `${isToday(date) ? 'Today' : isTomorrow(date) ? 'Tomorrow' : format(date, 'P')} at ${format(date, 'HH:mm')}`;

export const parseDate = (str: string | undefined) => {
  if (!str) {
    return undefined;
  }
  const date = Date.parse(str);
  if (Number.isNaN(date)) {
    return undefined;
  }
  return new Date(date);
};

export const formatDateRange = (startDate: number | Date, endDate: number | Date) => {
  const date = `${isToday(startDate) ? 'Today' : isTomorrow(startDate) ? 'Tomorrow' : format(startDate, 'LLL d')}`;
  const time = `${format(startDate, 'p')} - ${format(endDate, 'p')}`;
  return `${date} ${time}`;
};

/** Start of an event, without its end: "Today 1:00pm", "Tomorrow 9:30am", "Jul 24 1:00pm". */
export const formatEventStart = (startDate: number | Date) => {
  const date = isToday(startDate) ? 'Today' : isTomorrow(startDate) ? 'Tomorrow' : format(startDate, 'LLL d');
  return `${date} ${format(startDate, 'h:mmaaa')}`;
};

/** Rough event length for display: "15 min", "1 hr", "1 hr 30 min". */
export const formatApproxDuration = (durationMs: number) => {
  const totalMinutes = Math.max(1, Math.round(durationMs / 60000));
  if (totalMinutes < 60) {
    return `${totalMinutes} min`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return minutes ? `${hours} hr ${minutes} min` : `${hours} hr`;
};
